import Text from '@frontend/ui-kit/Components/Text';
import ContentSection from '@frontend/ui-kit/Components/ContentSection';
import BaseLayout from '../../../Components/shared/BaseLayout';
import ErrorContent from '../../../Components/Error/ErrorContent';
import {HTTP_CODE_TOO_MANY_REQUESTS} from '../../../constants';
import {gettext} from '../../../translationService';

const ManyRequests = () => {
    return (
        <BaseLayout>
            <ContentSection>
                <ErrorContent errorCode={HTTP_CODE_TOO_MANY_REQUESTS} title={gettext('Too Many Requests Error')}>
                    <Text>
                        {gettext('Oops! It appears that you have sent too many requests to our server within a short period. We apologize for any inconvenience caused.')}
                    </Text>
                </ErrorContent>
            </ContentSection>
        </BaseLayout>
    );
};

export {ManyRequests as TestableManyRequests};
export default ManyRequests;
